import React from "react";
import _ from "lodash";

import waitingStartBg from "assets/images/sbs/tot-new/waiting-start.png";
import waitingFooterLogo from "assets/images/sbs/tot-new/waiting-footer-logo.png";
import waitingPlayersBg from "assets/images/sbs/tot-new/waiting-players-bg.png";

const JoiningTOT = ({ users, lobby_params }) => {
  const waiting_to_start = _.get(
    lobby_params,
    "waiting_to_start",
    "Waiting to Start"
  );
  return (
    <div className="waiting-start-wrapper">
      <div className="waiting-start-bg">
        <img src={waitingStartBg} className="waitingStartImg" alt="" />
        <h2 className="waiting-txt">{waiting_to_start}</h2>
      </div>
      <div className="waiting-players-bg">
        <img src={waitingPlayersBg} alt="" />
        <div className="waiting-players-div">
          <div className="waiting-players-flex">
            {users.map((user) => (
              <div className="waiting-users">
                <img
                  src={user.profile_image}
                  className="waitingPlayerImg"
                  alt=""
                />
                <p className="user">{user.display_name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="waiting-tot-footer">
        <img src={waitingFooterLogo} alt="" />
      </div>
    </div>
  );
};

export default JoiningTOT;
